import React from "react";
import { Navigate, useParams } from "react-router-dom";

export default function CustomNavigate({ to = "/exam", withParams = true }) {
  const p = useParams();
  return withParams ? <Navigate to={to + p.id} /> : <Navigate to={to} />;
}
